<nb-header class="w-100" [fluid]="true" dbHeaderLinkConfig [shouldRemoveLogoLink]="true">
    <div class="ms-5">
        @if (isAuthenticated$ | async) {
            <a class="logout-link" href="#" (click)="onLogout()"><db-icon class="mr-1" size="md">document-sent</db-icon>{{'GLOBAL.logout_btn_txt' |
                translate}}</a>
        }
    </div>
</nb-header>
